import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// Self-hosted fonts (no cross-origin font dependency in the CSP).
import "@fontsource/inter/300.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/jetbrains-mono/500.css";

import App from "./App";
import "./index.css";
import { AuthProvider } from "@/auth/AuthProvider";
import { RequireAuth } from "@/auth/RequireAuth";
import { ErrorBoundary } from "@/components/system/ErrorBoundary";
import { LoginPage } from "@/routes/LoginPage";
import { ConsentPage } from "@/routes/ConsentPage";
import { RedirectModalPage } from "@/routes/RedirectModalPage";
import { SsoStartPage, SsoCallbackPage, SsoErrorPage, LogoutPage } from "@/routes/SsoExtraPages";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 15_000 },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/logout" element={<LogoutPage />} />
              <Route path="/sso/consent" element={<ConsentPage />} />
              <Route path="/sso/redirect" element={<RedirectModalPage />} />
              <Route path="/sso/error" element={<SsoErrorPage />} />
              <Route path="/sso/start" element={<SsoStartPage />} />
              <Route path="/sso/callback" element={<SsoCallbackPage />} />
              <Route
                path="/*"
                element={
                  <RequireAuth>
                    <App />
                  </RequireAuth>
                }
              />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
